module.exports = __webpack_public_path__ + "static/escrow-account_scheme-4a03742c3bc0c02b97f4cb5810f953e9.svg";